// Keyless dark basemap for MapLibre GL — uses CARTO's free "dark_all" raster tiles.
// No API token or domain allow-list required, so it works identically in preview & production.
export const DARK_MAP_STYLE = {
  version: 8,
  sources: {
    "carto-dark": {
      type: "raster",
      tiles: [
        "https://a.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}@2x.png",
        "https://b.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}@2x.png",
        "https://c.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}@2x.png",
        "https://d.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}@2x.png",
      ],
      tileSize: 256,
      attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> © <a href="https://carto.com/attributions">CARTO</a>',
    },
  },
  layers: [
    { id: "background", type: "background", paint: { "background-color": "#0b0b0c" } },
    { id: "carto-dark", type: "raster", source: "carto-dark", minzoom: 0, maxzoom: 22 },
  ],
};

// Keyless light basemap — CARTO's free "light_all" raster tiles (clean grey/white).
export const LIGHT_MAP_STYLE = {
  version: 8,
  sources: {
    "carto-light": {
      type: "raster",
      tiles: [
        "https://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}@2x.png",
        "https://b.basemaps.cartocdn.com/light_all/{z}/{x}/{y}@2x.png",
        "https://c.basemaps.cartocdn.com/light_all/{z}/{x}/{y}@2x.png",
        "https://d.basemaps.cartocdn.com/light_all/{z}/{x}/{y}@2x.png",
      ],
      tileSize: 256,
      attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> © <a href="https://carto.com/attributions">CARTO</a>',
    },
  },
  layers: [
    { id: "background", type: "background", paint: { "background-color": "#e8ecf0" } },
    { id: "carto-light", type: "raster", source: "carto-light", minzoom: 0, maxzoom: 22 },
  ],
};

// Pick a basemap that matches the active UI theme.
export const mapStyleFor = (theme) => (theme === "light" ? LIGHT_MAP_STYLE : DARK_MAP_STYLE);

// Neon yellow used for the run route/tracker line on the DARK basemap.
export const ROUTE_COLOR = "#eaff00";

// Theme-aware run route color. The neon yellow pops on the dark basemap but is
// almost invisible on the light grey basemap, so light mode uses a deep
// chartreuse that stays on-brand while reading clearly against light tiles.
export const routeColorFor = (theme) => (theme === "light" ? "#5e7a00" : ROUTE_COLOR);
